/**
 * Layer
 */
export default class Layer {
  defaults() {
    this.layerClass = "layer-module";
    this.layerOpenClass = "layer-open";
    this.dimmedClass = "dimmed";
    this.keepdimmedClass = "keep-dimmed";
    this.dimmedElement = '<div class="' + this.dimmedClass + '"></div>';

    return {
      enforceInitFocus: false,
      bActivated: true,
      keepDimmed: false,
      closeButton: '[data-layer-close="close"]'
    };
  }

  constructor(settings) {
    this.$layer = settings.layer;
    this.$linked = settings.linked;
    this.options = $.extend({}, this.defaults(), settings.options);

    this.onBeforeShowCallback = settings.onBeforeShow;
    this.onShowCallback = settings.onShow;
    this.onBeforeHideCallback = settings.onBeforeHide;
    this.onHideCallback = settings.onHide;

    this.cachedBeforePosY = 0;

    this.init();
  }

  activate() {
    this.show();
  }

  deactivate() {
    this.hide();
    this.reset();
  }

  init() {
    this.assignedElements();
    this.appendDimmed();
    this.unbindAllEvents();
    this.bindEvents();

    if (this.options.bActivated) {
      this.activate();
    }
  }

  assignedElements() {
    this.$wrap = this.$layer.children(".layer-wrap");
    this.$closeButton = this.$layer.find(this.options.closeButton);
  }

  appendModuleClass() {
    var layerIntClass = this.layerClass;

    if (this.$layer.hasClass(layerIntClass)) {
      return;
    }

    this.$layer.addClass(layerIntClass);
  }

  appendDimmed() {
    if (!this.$layer.children().hasClass("dimmed")) {
      this.$layer.prepend(this.dimmedElement);
    }

    this.$dimmed = this.$layer.find("." + this.dimmedClass);
  }

  unbindAllEvents() {
    $(window).off("resize", e => this.onResize(e));
    this.$closeButton.off("click", e => this.onClickCloseButton(e));
    this.$dimmed.off("click touchstart", e => this.onClickDimmed(e));
  }

  bindEvents() {
    $(window).off("resize");
    $(window).on("resize", e => this.onResize(e));

    this.$wrap.resize(e => this.onResize(e));

    this.$closeButton.off("click");
    this.$closeButton.on("click", e => this.onClickCloseButton(e));

    if (!this.options.keepDimmed) {
      this.$dimmed.off("click touchstart");
      this.$dimmed.on("click touchstart", e => this.onClickCloseButton(e));
    } else {
      this.$dimmed.addClass(this.keepdimmedClass);
    }
  }

  onResize() {
    this.reposition();
  }

  onClickCloseButton(e) {
    e.preventDefault();
    // console.log("click close button");
    $("body").removeClass(this.layerOpenClass);

    this.hide();
    this.reset();
  }

  isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  reset() {
    //this.unbindAllEvents();
    this.$wrap.removeAttr("style");
    $("body").removeAttr("style");
    this.$layer.removeClass(this.layerClass);
    this.$dimmed.removeClass(this.keepdimmedClass);
  }

  getLayer() {
    return this.$layer;
  }

  getLinked() {
    return this.$linked ? this.$linked : null;
  }

  isVisible() {
    return this.$layer.css("display") === "block";
  }

  show() {
    if (this.isTouchDevice()) {
      this.cachedBeforePosY = window.scrollY;
      document.getElementsByTagName("body")[0].style.top =
        -this.cachedBeforePosY + "px";
    }

    if (typeof this.onBeforeShowCallback === "function") {
      this.onBeforeShowCallback.apply(this, [this.getData("layer.beforeShow")]);
    }
    this.$layer.trigger(this.getData("layer.beforeShow"));

    this.appendModuleClass();

    this.$layer.show();

    this.showDimmed();
    this.reposition();

    if (this.options.enforceInitFocus) {
      this.enforceFocusLayer();
    }

    if (typeof this.onShowCallback === "function") {
      this.onShowCallback.apply(this, [this.getData("layer.show")]);
    }

    this.$layer.trigger(this.getData("layer.show"));
  }

  hide() {
    if (typeof this.onBeforeHideCallback === "function") {
      this.onBeforeHideCallback.apply(this, [this.getData("layer.beforeHide")]);
    }

    this.$layer.trigger(this.getData("layer.beforeHide"));

    this.$layer.hide();
    this.hideDimmed();

    this.reset();

    if (this.isTouchDevice()) {
      $(window).scrollTop(this.cachedBeforePosY);
    }

    this.enforceFocusLinked();

    if (typeof this.onHideCallback === "function") {
      this.onHideCallback.apply(this, [this.getData("layer.hide")]);
    }

    this.$layer.trigger(this.getData("layer.hide"));
  }

  reposition() {

    var $wrap = this.$wrap,
      left = 0,
      top = 0;

    if ($('body').hasClass('mobile')) {
      left = 0;
    } else {
      left = parseInt(
        (document.documentElement.clientWidth - $wrap.outerWidth()) * 0.5
      );
    }
    top = parseInt(
      (document.documentElement.clientHeight - $wrap.outerHeight()) * 0.5
    );

    top = top <= 0 ? 0 : top;

    $wrap.css({
      top: top,
      left: left
    });
  }

  showDimmed() {
    this.$dimmed.show();

    $("body").addClass(this.layerOpenClass);
  }

  hideDimmed() {
    this.$dimmed.hide();

    $("body").removeClass(this.layerOpenClass);
  }

  enforceFocusLayer() {
    var $wrap = this.$wrap;

    var timer = setTimeout(function () {
      $wrap.attr("tabindex", -1).focus();
      clearTimeout(timer);
    }, 50);
  }

  enforceFocusLinked() {
    var _this = this;

    if (!this.$linked) return;

    var timer = setTimeout(function () {
      _this.$linked.focus();
      clearTimeout(timer);
    }, 50);
  }

  getData(customEventName) {
    return {
      type: customEventName,
      manager: this,
      layer: this.$layer,
      linked: this.getLinked()
    };
  }

  //global
  forceHide() {
    this.$closeButton.trigger("click");
  }
}
